// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEntityDetails_Entity_DocumentFragment = { __typename?: 'Document', id: string, name: string, type: Types.DocumentType, entity?: { __typename?: 'Entity', id: string } | null, summaries?: Array<{ __typename?: 'DocumentSummary', id: string, displayName: string }> | null, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, entityID?: string | null, documentID: string } | null } | null> | null } };

export type GetHouseholdDocumentsQueryVariables = Types.Exact<{
  documentWhere: Types.DocumentWhereInput;
}>;


export type GetHouseholdDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: (
        { __typename?: 'Document' }
        & GetEntityDetails_Entity_DocumentFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetHouseholdDocuments: 'GetHouseholdDocuments' as const
  },
  Fragment: {
    GetEntityDetails_Entity_Document: 'GetEntityDetails_Entity_Document' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GetEntityDetails_Entity_DocumentFragmentDoc = gql`
    fragment GetEntityDetails_Entity_Document on Document {
  id
  name
  type
  entity {
    id
  }
  summaries {
    id
    displayName
  }
  entityDocumentRelationships {
    edges {
      node {
        id
        entityID
        documentID
      }
    }
  }
}
    `;
export const GetHouseholdDocumentsDocument = gql`
    query GetHouseholdDocuments($documentWhere: DocumentWhereInput!) {
  documents(where: $documentWhere) {
    edges {
      node {
        ...GetEntityDetails_Entity_Document
      }
    }
  }
}
    ${GetEntityDetails_Entity_DocumentFragmentDoc}`;

/**
 * __useGetHouseholdDocumentsQuery__
 *
 * To run a query within a React component, call `useGetHouseholdDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHouseholdDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHouseholdDocumentsQuery({
 *   variables: {
 *      documentWhere: // value for 'documentWhere'
 *   },
 * });
 */
export function useGetHouseholdDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetHouseholdDocumentsQuery, GetHouseholdDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHouseholdDocumentsQuery, GetHouseholdDocumentsQueryVariables>(GetHouseholdDocumentsDocument, withFetchPolicyContext(options));
      }
export function useGetHouseholdDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHouseholdDocumentsQuery, GetHouseholdDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHouseholdDocumentsQuery, GetHouseholdDocumentsQueryVariables>(GetHouseholdDocumentsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetHouseholdDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHouseholdDocumentsQuery, GetHouseholdDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHouseholdDocumentsQuery, GetHouseholdDocumentsQueryVariables>(GetHouseholdDocumentsDocument, withFetchPolicyContext(options));
        }
export type GetHouseholdDocumentsQueryHookResult = ReturnType<typeof useGetHouseholdDocumentsQuery>;
export type GetHouseholdDocumentsLazyQueryHookResult = ReturnType<typeof useGetHouseholdDocumentsLazyQuery>;
export type GetHouseholdDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetHouseholdDocumentsSuspenseQuery>;
export type GetHouseholdDocumentsQueryResult = Apollo.QueryResult<GetHouseholdDocumentsQuery, GetHouseholdDocumentsQueryVariables>;